import { createContext, useContext } from 'react';

// context that holds a connection ID
export const ConnectionContext = createContext<string>('');

// useConnection is a hook that returns the connection ID
export const useConnection = () => useContext(ConnectionContext);
